// Constantes reutilizables para KonvaBoard
export const ARROW_HEAD_LEN = 18;

// Umbral (px) para enlazar una flecha al elemento más cercano al dibujarla
export const ARROW_LINK_PROXIMITY = 30;

export const DRIBBLE_AMPLITUDE = 8;
export const DRIBBLE_WAVELENGTH = 16;
export const DRIBBLE_FINAL_OFFSET = 4;
export const CURVED_DRIBBLE_HEAD_OFFSET = 12;
export const CURVED_SAMPLES_DIV = 4;

export const RDP_EPS_MIN = 8;
export const RDP_EPS_FACTOR = 0.08;

export const CPS_MARGIN_DIST_MIN = 6;
export const CPS_MARGIN_FACTOR = 0.02;
export const CPS_MERGE_DIST_MIN = 18;
export const CPS_MERGE_FACTOR = 0.03;

export const SHORT_STROKE_MIN = 8;
export const CURVATURE_SUM_MIN = 1.0;

export const ABS_CURV_THRESHOLD = 0.28;
export const REL_CURV_THRESHOLD = 0.06;
export const SIGNIFICANCE_BASE = 0.18;
export const SIGNIFICANCE_REL = 0.18;
export const REL_CUT = 0.03;
export const MARGIN_SAMPLES_FACTOR = 0.06;
export const MARGIN_SAMPLES_MIN = 4;

export const CPS_MIN_SEPARATION = 3;
export const WIN_MIN = 2;

// Dibujo de flechas
/** Distancia mínima (px) para muestrear un punto del trazo del pincel. */
export const BRUSH_SAMPLE_MIN_DIST = 4;
/** Longitud (px) de la marca perpendicular de las flechas de bloqueo. */
export const BLOCK_PERP_LEN = 8;
/** Separación (px) entre las dos líneas paralelas del tiro. */
export const SHOT_LINE_OFFSET = 4;
/** Longitud (px) de la cabeza del tiro. */
export const SHOT_ARROW_HEAD_LEN = 18;
/** Punta de flecha por defecto en las vistas previas. */
export const ARROW_POINTER_LENGTH = 10;
export const ARROW_POINTER_WIDTH = 8;
/** Zona de transición suave al final de los dribbles. */
export const TRANSITION_LEN = 18;
/** Distancia (px) hacia atrás para promediar el ángulo de la cabeza. */
export const LOOKBACK_DISTANCE = 35;

// Interacción
/** Pulsación larga (ms) para borrar/convertir mangos y añadir puntos de control. */
export const LONG_PRESS_MS = 600;

// Reproducción y exportación
/** Margen de error al comparar instantes de la línea de tiempo. */
export const PLAYBACK_EPSILON = 0.001;

/** Habilita la rotación automática de jugadores/defensores durante la animación
 *  para que el número mire hacia la cola de la flecha (atrás) y la parte baja
 *  hacia la punta (adelante). Poner a false para desactivar y mantener el
 *  comportamiento anterior (número siempre erguido). */
export const ENABLE_PLAYER_ROTATION_DURING_PLAYBACK = true;
/** Factor de calidad para exportaciones (PNG, WebP, vídeo). */
export const EXPORT_PIXEL_RATIO = 2;
/** Frames por segundo del export offline (WebCodecs). */
export const EXPORT_FPS = 30;
/** Bitrate (bps) del export offline (H.264 a 2x). */
export const EXPORT_BITRATE = 8_000_000;
/** Keyframe cada N frames (~2 s a 30 fps) en el export offline. */
export const EXPORT_KEYFRAME_INTERVAL = 60;
/** Escala máxima permitida al hacer zoom (pantalla completa). */
export const MAX_ZOOM_SCALE = 2;

// Nodos y UI
export const PLAYER_RADIUS = 14;
export const PLAYER_STROKE_WIDTH = 3;
export const PLAYER_TEXT_SIZE = 16;
export const SELECTION_RING_RADIUS = 18;
export const SELECTION_RING_STROKE_WIDTH = 2;
export const ROTATION_HANDLE_RADIUS = 5;
export const ROTATION_HANDLE_Y = -28;

export const DEFENDER_BODY_RADIUS = 12;
export const DEFENDER_ARMS_STROKE = 6;
export const DEFENDER_TEXT_SIZE = 13;

export const ICON_RADIUS_BALL = 8;
export const ICON_RADIUS_DEFAULT = 16;

// Texto
export const TEXT_FONT_SIZE = 18;
export const TEXT_FONT_FAMILY = 'Arial, sans-serif';
export const TEXT_CARET_WIDTH = 2;
export const TEXT_CARET_BLINK_MS = 530;
export const TEXT_SELECTION_PADDING = 4;
export const TEXT_MIN_WIDTH = 4;
